import { render, staticRenderFns } from "./PermissionsPermissionTypesView.vue?vue&type=template&id=7cb727c9&"
import script from "./PermissionsPermissionTypesView.vue?vue&type=script&lang=js&"
export * from "./PermissionsPermissionTypesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports